import React, { useEffect } from "react";
import AutoSuggestInput from "../../AutoSuggestInput";
import { useState } from "react";
import DatePicked from "./DatePicked";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import useSetAddress from "../../../Global/Api/Schedule/setAddress";
import {
  setHoursWork, 
  setTechnician, 
  incrementRadius as incrementRadiusAction, 
  decrementRadius as decrementRadiusAction
} from "../../../Store/Slice/scheduleSlice";
import useGetTechniciansForMonth from "../../../Global/Api/Schedule/getTechniciansForMonth";
import {useGetLocationsQuery} from "../../../Store/Builder/techsbook.api";
import {useParams} from "react-router-dom";

export default function Form({isDatePast}) {
  const {title: jobTitle} = useParams();
  const dispatch = useDispatch();
  const timesInMonth = useGetTechniciansForMonth();
  const setAddressData = useSetAddress();
  const { data, isLoading: locationsIsLoading } = useGetLocationsQuery();
  const accountData = useSelector((state) => state.rootReducer.techsbookSlice.userData);
  const  radius = useSelector((state) => state.rootReducer.scheduleSlice.radius);
  const { job_address, date, time } = useSelector((state) => state.rootReducer.scheduleSlice.tech);
  const timeList = useSelector((state) => state.rootReducer.scheduleSlice.hoursWork);

  const [activePicker, setActivePicker] = useState(false);

  const handlePicker = async () => {
    setActivePicker(!activePicker);
    if (!activePicker && timeList === null) {
      timesInMonth.get(
          // jobTitle
          // ? parseInt(moment(JSON.parse(date)).format("YYYY"))
          // :
      parseInt(moment(new Date).format("YYYY")),
        // jobTitle
          // ? parseInt(moment(JSON.parse(date)).format("MM"))
          // :
      parseInt(moment(new Date).format("MM")),
      );
    }
  };

  const incrementRadius = () => {
    if(radius < accountData?.radius_for_tech){
      dispatch(incrementRadiusAction(radius + 50))
    } 
  }
  const decrementRadius = () => {
    if(radius > 50){
      dispatch(decrementRadiusAction(radius - 50))
    } 
  }

  useEffect(() => {
    if (!jobTitle) {
      setActivePicker(false);
    }
  }, [jobTitle]);

  const handleAddressChange = (e) => {
    setActivePicker(false);
    dispatch(
      setTechnician({
        job_address: e,
      })
    );
    dispatch(setHoursWork(null));
    if (!jobTitle) {
      setAddressData.set(e);
    }
    if (e !== job_address?.address && !jobTitle) {
      dispatch(setTechnician({
        date: null,
        time: null,
      }));
    }
  };

  return (
    <>
      <div className="tech__search">
        <div className="scheduling-first">
          <div style={{width: '20%'}}>
            <label htmlFor="radius">Technician Radius</label>
            <div id="radius" className="count--input">
              <div
                suppressContentEditableWarning={true}
                className={`count--input__number`}
                contentEditable={!radius}
              >
                { radius }
              </div>
              <div className="count--input__btns">
                <div
                  className={`count--input__up ${
                    radius === accountData?.radius_for_tech ? "disabled" : ""
                  }`}
                >
                  <img onClick={incrementRadius} src="/assets/icons/up-count.svg" alt="up" />
                </div>
                <div
                  className={`count--input__down ${
                    radius === 50 ? "disabled" : ""
                  }`}
                >
                  <img
                    onClick={decrementRadius}
                    src="/assets/icons/down-count.svg"
                    alt="down"
                  />
                </div>
              </div>
            </div>
          </div>
          <div style={{width: '80%'}}>
            <label htmlFor="search">Service location</label>
              <div className="input" style={{width: '60%'}}>
                <img src="/assets/icons/locations.svg" alt="location" />
                <AutoSuggestInput
                    disabled={jobTitle && jobTitle?.length}
                    prevLocations={data}
                    address={job_address?.address ?? ""}
                    handleAddressChange={handleAddressChange}
                    placeholder="Enter location"
                />
              </div>
          </div>
        </div>
        
      </div>
      <div className="tech__row">
        <div className="tech__date">
          <h4>Date and time</h4>
          <div
            className={`tech__date-block ${activePicker ? "active" : ""}`}
            onClick={handlePicker}
            style={{
              border: jobTitle && isDatePast ? '1px solid red' : ''
            }}
          >
            <div className="tech__date-day">
              {date ? (
                <div>{moment(JSON.parse(date)).format("MMM DD, YYYY")}</div>
              ) : (
                <span>Picked Date</span>
              )}
              <span>
                <img src="/assets/icons/calendar.svg" alt="calendar" />
              </span>
            </div>
            <div className="tech__date-hr"></div>
            <div className="tech__date-time">
              {time ? <div>{time?.label}</div> : <span>Picked Time</span>}
              <span>
                <img src="/assets/icons/clock.svg" alt="clock" />
              </span>
            </div>
          </div>
          {activePicker ? (
            <DatePicked setActivePicker={setActivePicker} />
          ) : null}
        </div>
      </div>
    </>
  );
}
